import { Guest } from '@/app/system/guest/Guest';
import { GuestAware } from '@/app/system/guest/GuestAware';
import { GuestInTheMiddle } from '@/app/system/guest/GuestInTheMiddle';
import { Source } from '@/app/system/guest/Source';

export class SourceEmpty<T> implements GuestAware<T>, Guest<T> {
  private baseSource = new Source(null as T | null);

  public receiving(guest: Guest<T>) {
    this.baseSource.receiving(
      new GuestInTheMiddle(guest, value => {
        if (value !== null) {
          guest.receive(value);
        }
      }),
    );
    return this;
  }

  public receive(value: T): this {
    this.baseSource.receive(value);
    return this;
  }

  introduction(): 'guest' | 'patron' {
    return 'guest';
  }
}
